export default "__VITE_ASSET__DikQ3Z5f__"